<app-vertical-bar-graph 
    [graph]="this.data.graph.data[currentBUIndex].data[currentSBUIndex].data"
    (onBarSelect)="onSelectGarphValue($event)" 
    [type]="getBarType(data)">
</app-vertical-bar-graph>